var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecruitEntryIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "recruit_entry_icon2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.545,
    height: 55.6,
    viewBox: "0 0 55.545 55.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184200",
    "data-name": "\\uADF8\\uB8F9 184200",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131954",
    "data-name": "\\uD328\\uC2A4 131954",
    d: "M499.115,180.034a4.215,4.215,0,0,0-5.961-.013l-17.119,17.048a4.215,4.215,0,0,0-.012,5.962l29.331,29.454a4.216,4.216,0,0,0,5.962.013l17.119-17.048a4.215,4.215,0,0,0,.012-5.961Z",
    transform: "translate(-474.461 -178.459)",
    fill: "#ffbf17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131955",
    "data-name": "\\uD328\\uC2A4 131955",
    d: "M499.087,179.531a4.518,4.518,0,0,0-3.214-1.338h-.009a4.519,4.519,0,0,0-3.209,1.326l-17.12,17.048A4.554,4.554,0,0,0,475.52,203l29.332,29.454a4.514,4.514,0,0,0,3.213,1.339h.01a4.52,4.52,0,0,0,3.21-1.326l17.119-17.048a4.555,4.555,0,0,0,.013-6.433Zm28.846,35.415-17.118,17.048a3.885,3.885,0,0,1-5.489-.011l-29.332-29.454a3.884,3.884,0,0,1,.012-5.488l17.118-17.049a3.885,3.885,0,0,1,5.489.012l29.332,29.453A3.885,3.885,0,0,1,527.933,214.946Z",
    transform: "translate(-474.197 -178.193)",
    fill: "#111"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184201",
    "data-name": "\\uADF8\\uB8F9 184201",
    transform: "translate(1.337 15.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131956",
    "data-name": "\\uD328\\uC2A4 131956",
    d: "M509.99,216.069a5.982,5.982,0,0,0-4.548-4.559L483,206.581a5.939,5.939,0,0,0-5.487,1.6l-.919.914.472.474.918-.915a5.271,5.271,0,0,1,4.872-1.42l22.437,4.928a5.309,5.309,0,0,1,4.038,4.048l4.891,22.524a5.273,5.273,0,0,1-1.438,4.876l-.108.108.473.472.107-.107a5.938,5.938,0,0,0,1.62-5.49Z",
    transform: "translate(-476.599 -206.441)",
    fill: "#111"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184202",
    "data-name": "\\uADF8\\uB8F9 184202",
    transform: "translate(14.71 4.56)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154168",
    "data-name": "\\uC0AC\\uAC01\\uD615 154168",
    width: 13.382,
    height: 0.667,
    transform: "translate(0 13.374) rotate(-88.04)",
    fill: "#111"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184203",
    "data-name": "\\uADF8\\uB8F9 184203",
    transform: "translate(37.495 39.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131957",
    "data-name": "\\uD328\\uC2A4 131957",
    d: "M541.574,250.051l.02.668,13.377-.4-.021-.668Z",
    transform: "translate(-541.574 -249.646)",
    fill: "#111"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184204",
    "data-name": "\\uADF8\\uB8F9 184204",
    transform: "translate(43.796 27.911)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154169",
    "data-name": "\\uC0AC\\uAC01\\uD615 154169",
    width: 4.756,
    height: 7.775,
    transform: "matrix(0.709, -0.706, 0.706, 0.709, 0, 3.356)",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184207",
    "data-name": "\\uADF8\\uB8F9 184207",
    transform: "translate(40.394 24.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184205",
    "data-name": "\\uADF8\\uB8F9 184205",
    transform: "translate(0 1.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131958",
    "data-name": "\\uD328\\uC2A4 131958",
    d: "M553.01,229.3a1.962,1.962,0,0,0-1.122-.577,1.389,1.389,0,0,1-1.18-1.184,2.052,2.052,0,0,0-1.7-1.7,1.4,1.4,0,0,1-1.182-1.187,1.975,1.975,0,0,0-.573-1.127l-.474.472a1.31,1.31,0,0,1,.393.79,2.056,2.056,0,0,0,1.7,1.7,1.4,1.4,0,0,1,1.18,1.185,2.052,2.052,0,0,0,1.7,1.7,1.385,1.385,0,0,1,1.179,1.183,1.961,1.961,0,0,0,.572,1.126l.474-.472a1.3,1.3,0,0,1-.392-.787A1.963,1.963,0,0,0,553.01,229.3Z",
    transform: "translate(-546.783 -223.519)",
    fill: "#111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_184206",
    "data-name": "\\uADF8\\uB8F9 184206",
    transform: "translate(1.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131959",
    "data-name": "\\uD328\\uC2A4 131959",
    d: "M555.179,227.138a1.973,1.973,0,0,0-1.122-.577,1.389,1.389,0,0,1-1.18-1.183,2.054,2.054,0,0,0-1.7-1.7A1.395,1.395,0,0,1,550,222.488a1.964,1.964,0,0,0-.573-1.127l-.473.471a1.314,1.314,0,0,1,.392.791,2.057,2.057,0,0,0,1.7,1.7,1.394,1.394,0,0,1,1.181,1.185,2.049,2.049,0,0,0,1.7,1.7A1.387,1.387,0,0,1,555.1,228.4a1.965,1.965,0,0,0,.571,1.125l.474-.471a1.3,1.3,0,0,1-.392-.788A1.962,1.962,0,0,0,555.179,227.138Z",
    transform: "translate(-548.953 -221.361)",
    fill: "#111"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitEntryIcon2);
export default __webpack_public_path__ + "static/media/recruit_entry_icon2.a11fdcb4605dbe07cd89d27a8a798023.svg";
export { ForwardRef as ReactComponent };